import React from "react";
import Footer from "../../components/Footer/footer";
import Header from "../../components/Header/header";
import Icons from "../../config/images";
import "./about.css";
import AboutImage from "./Component/AboutImage/aboutImage";
import MeetTeam from "./Component/MeetTeam/meetTeam";
import StorySection from "./Component/Story/story";
import WhyChooseSection from "./Component/WhyChoose/whyChoose";

// const MeetTeam = () => {
//   const features = [
//     {
//       icons: Icons.teamMembers,
//       title: "Same Moore",
//       description: "Front End Developer",
//     },
//     {
//       icons: Icons.teamMembers,
//       title: "Same Moore",
//       description: "Front End Developer",
//     },
//     {
//       icons: Icons.teamMembers,
//       title: "Same Moore",
//       description: "Front End Developer",
//     },
//     {
//       icons: Icons.teamMembers,
//       title: "Same Moore",
//       description: "Front End Developer",
//     },
//   ];

//   return (
//     <section className="why-choose-us">
//       <h2>Why Choose Us?</h2>
//       <div className="features-grid">
//         {features?.map((feature, index) => (
//           <div key={index} className="team-feature-view">
//             <img
//               src={feature.icons}
//               alt="icons"
//               className="team-icon-style"
//             />
//             <p className="team-feature-title-style">{feature.title}</p>
//             <p className="team-feature-description-style">
//               {feature.description}
//             </p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// const MissionVision = () => {
//   return (
//     <section className="mission-vision">
//       <div className="story">
//         <h2>Our Story</h2>
//         <p>
//           Our story began with a simple vision: to empower businesses with
//           innovative digital solutions...
//         </p>
//       </div>
//       <div className="mission">
//         <h2>Our Mission & Vision</h2>
//         <p>
//           <strong>Mission:</strong> To transform ideas into reality...
//         </p>
//         <p>
//           <strong>Vision:</strong> To be the trusted partner for businesses
//           worldwide...
//         </p>
//       </div>
//     </section>
//   );
// };


const AboutPage = () => {
  return (
    <div className="about-page-main-container-style">
      <Header />

      <div className="about-page-side-padding-style">
        <AboutImage />
        <div className="about-page-row-content-style">
          <StorySection />
        </div>
        <WhyChooseSection />
        <MeetTeam />
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
